import React, { Component } from 'react'
import { TextInput } from '@resurs/midas-react'
import PropTypes from 'prop-types'
import IconButton from '../../../../../internal/IconButton'
import { getText } from '../../../../../internal/TextLabels'
import { format } from '../../../../../models/format'
import { setNestedValue } from '../../../../../util/helpers'
import { validateSENaturalGovernmentId } from '../../../../../util/governmentIdUtils'
import Description from './Description'
import styles from './styles.module.scss'

const _emptyCardHolder = () => ({
  firstName: '',
  lastName: '',
  governmentId: '',
})

const _isEmpty = cardHolder =>
  !cardHolder.firstName && !cardHolder.lastName && !cardHolder.governmentId

const _isInvalid = cardHolder =>
  !cardHolder.firstName ||
  !cardHolder.lastName ||
  !validateSENaturalGovernmentId(cardHolder.governmentId)

class CardHolders extends Component {
  constructor(props) {
    super(props)
    this.state = {
      cardHolders: (props.initialValue &&
        props.initialValue.length &&
        props.initialValue.map(v => ({ ...v }))) || [_emptyCardHolder()],
      autoFocus: false,
    }
    this.notifyParent()
  }

  addCardHolder() {
    this.setState(({ cardHolders }) => ({
      cardHolders: [...cardHolders, _emptyCardHolder()],
      autoFocus: true,
    }))
  }

  removeCardHolder(index) {
    this.setState(
      ({ cardHolders }) => ({
        cardHolders: [
          ...cardHolders.slice(0, index),
          ...cardHolders.slice(index + 1),
        ],
      }),
      this.notifyParent,
    )
  }

  updateCardHolder(index, key, e) {
    this.setState(
      ({ cardHolders }) => ({
        cardHolders: [
          ...cardHolders.slice(0, index),
          setNestedValue(cardHolders[index], key, e.target.value),
          ...cardHolders.slice(index + 1),
        ],
      }),
      this.notifyParent,
    )
  }

  notifyParent() {
    const cardHolders = this.state.cardHolders.filter(e => !_isEmpty(e))
    this.props.onChange({
      cardHolders,
      valid: cardHolders.length && !cardHolders.filter(_isInvalid).length,
    })
  }

  render() {
    const { cardHolders } = this.state
    const { disabled } = this.props
    return (
      <>
        <Description
          heading={getText('payApply.business.cardHolders.heading')}
          text={getText('payApply.business.cardHolders.description')}
        />
        {cardHolders.map((cardHolder, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={styles.row} key={i}>
            <div className={styles.cardHolderColumn}>
              <TextInput
                id="firstName"
                label={getText('payApply.business.cardHolders.firstName')}
                value={cardHolder.firstName}
                onChange={e => this.updateCardHolder(i, 'firstName', e)}
                format={format.shortString}
                required={getText('default.form.required')}
                autoFocus={this.state.autoFocus}
                disabled={disabled}
              />
              <TextInput
                id="lastName"
                label={getText('payApply.business.cardHolders.lastName')}
                value={cardHolder.lastName}
                onChange={e => this.updateCardHolder(i, 'lastName', e)}
                format={format.shortString}
                required={getText('default.form.required')}
                disabled={disabled}
              />
              <TextInput
                id="governmentId"
                label={getText('payApply.business.cardHolders.governmentId')}
                value={cardHolder.governmentId}
                onChange={e => this.updateCardHolder(i, 'governmentId', e)}
                format={format.governmentId.SE}
                additionalValidation={v =>
                  !validateSENaturalGovernmentId(v) &&
                  getText('default.form.formatError.governmentIdNatural')
                }
                required={getText('default.form.required')}
                disabled={disabled}
              />
            </div>
            <div className={styles.buttonContainer}>
              <IconButton
                icon="midasAdd3"
                onClick={() => this.addCardHolder()}
                onSubmit={e => e.preventDefault()}
                disabled={
                  disabled ||
                  i !== cardHolders.length - 1 ||
                  _isEmpty(cardHolders[cardHolders.length - 1])
                }
              />
              <IconButton
                icon="midasMinus3"
                disabled={disabled || cardHolders.length === 1}
                onClick={() => this.removeCardHolder(i)}
                onSubmit={e => e.preventDefault()}
                tabIndex={-1}
              />
            </div>
          </div>
        ))}
      </>
    )
  }
}

CardHolders.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialValue: PropTypes.array,
  disabled: PropTypes.bool,
}

CardHolders.defaultProps = {
  initialValue: [],
  disabled: false,
}

export default CardHolders
